import {ButtonKind} from "../ButtonKind";

export default function buttonTypeClass(type?: ButtonKind): string {
	const className = "form__button";
	switch (type) {
		case "primary":
			return className + " form__button--primary";

		case "confirm":
			return className + " form__button--confirm";

		case "destroy":
			return className + " form__button--destroy";

		default:
			return className;
	}
}
